import {reachGoal} from 'utils/metrica';
import {formatReferenceCopy} from 'utils/typography';
import React from "react";
import {useTranslation} from "react-i18next";

import { Check as CheckIcon } from '@vedmarket/ui-kit';
import Button from "@mui/material/Button";

import {
  useBankCommissions,
  useGetBankCommissionsByOrderIdQuery,
  useInvoices, useLazyGetOrderSummaryByIdQuery, useSetCompletedByOrderIdMutation, useSummaryCompleted,
} from "../../../../../api/calc";
import {useGetCalcIdFromRoute} from "../../../../../utils/hooks";
import {useDemoBankCommissionSave} from 'components/cabinet/demo/steps/payment/use-payment';

import Invoice from './components/invoice';
import {isCalculationViewModeError} from 'utils/helpers';
import {useCalculationReadOnly} from '../../calculation-read-only';


type Props = {
  handleComplete(): void
}

const BankCommission = ({handleComplete} : Props) => {

  const { t } = useTranslation();

  const copy = (key: string) => formatReferenceCopy(t(key));

  const demoPlayback = useDemoBankCommissionSave()
  const readOnly = useCalculationReadOnly()

  const orderId = useGetCalcIdFromRoute()

  const summaryCompleted = useSummaryCompleted()

  const bankCommissionsInvoice = useBankCommissions();

  const { refetch: fetchBankCommissions } = useGetBankCommissionsByOrderIdQuery({orderId})

  const invoices = useInvoices();

  const [ setCompleted ] = useSetCompletedByOrderIdMutation()
  const [ getOrderSummaryRequest ] = useLazyGetOrderSummaryByIdQuery()

  if (!invoices){
    return null;
  }

  const handleClickCompleted = async () => {
    if (demoPlayback.isDemoMode) {
      handleComplete();
      demoPlayback.complete()
      return
    }

    const result = await setCompleted({
      orderId,
      banking_commissions: true,
    })

    if (isCalculationViewModeError(result)) {
      return;
    }

    getOrderSummaryRequest(orderId);
    handleComplete();
  }

  const shouldShowSummaryBankCommissions = bankCommissionsInvoice?.invoices.every(invoice => invoice.banking_commissions.length);
  const canSaveBankCommissions = !summaryCompleted?.banking_commissions || demoPlayback.isDemoMode
  const shouldShowSaveButton = canSaveBankCommissions && shouldShowSummaryBankCommissions

  return (
    <>
      {invoices.map((invoice, index) => (
        <Invoice invoice={invoice} key={invoice.id} index={index} refetch={fetchBankCommissions}/>
      ))}
      {shouldShowSaveButton && (
        <Button
          {...demoPlayback.saveButtonProps}
          variant='contained'
          fullWidth
          startIcon={<CheckIcon />}
          onClick={() => {
            reachGoal({ goal: 'info_po_komissii' });
            handleClickCompleted();
          }}
          disabled={readOnly}
        >
          {copy('calc__text__bankCommissions__savePaymentAndCommissionInformation')}
        </Button>
      )}
    </>
  )
}

export default BankCommission
